var i18n = {
  'en-US': {
    'autoSave.loading': 'auto saving...',
    'autoSave.autosaved': 'Autosaved',
    'autoSave.modal.edit.history': 'View edit history',
    'autoSave.modal.title': 'Error message',
    'autoSave.modal.content': 'The current preview theme is not the latest version and cannot be saved, please refresh the page before editing',
    'autoSave.modal.error': 'Failed to save:',
    'dropdown.message.deleted': 'Deleted',
    'dropdown.packageName.published': 'Published',
    'dropdown.packageName.unpublish': 'Not yet published',
    'dropdown.ThemeEdit.setting.tip': 'Theme settings',
    'dropdown.ThemeEdit.delete.tip': 'Delete theme',
    'dropdown.ThemeEdit.delete.confirm.desc': 'After deleting the topic, the topic will not be accessible under the current URL, please operate with caution!',
    'dropdown.ThemeEdit.delete.btn': 'Delete',
    'dropdown.ThemeEdit.cancel.btn': 'Cancel',
    'dropdown.ThemeEdit.copy.success': 'Copied to clipboard',
    'dropdown.ThemeEdit.copy.error': 'Copy failed',
    'dropdown.ThemeEdit.supplement.text': 'Check ',
    'dropdown.ThemeEdit.supplement.history': 'Version record',
    'dropdown.ThemeEdit.menu.title': 'Arco Library Version',
    'dropdown.ThemeEdit.menu.tag.latest': 'Latest',
    'dropdown.ThemeEdit.menu.tag.updatable': 'Updatable',
    'dropdown.ThemeEdit.origin.title': 'View parent theme',
    'dropdown.ThemeEdit.origin.synchronization': 'Synchronize',
    'dropdown.ThemeEdit.origin.check': 'View',
    'dropdown.ThemeEdit.toggle.title': 'Toggle themes',
    'dropdown.ThemeEdit.preview': 'Theme preview',
    'dropdown.ThemeEdit.config': 'Configuration details',
    'preview.action.back': 'Back to configuration',
    'preview.pkgname.text': 'Effect preview',
    'preview.action.guideline': 'Guideline',
    'preview.action.publish': 'Publish',
    'preview.version': 'Preview version',
    'preview.version.current': 'The current preview version is'
  },
  'zh-CN': {
    'autoSave.loading': '自动保存中...',
    'autoSave.autosaved': '已自动保存',
    'autoSave.modal.title': '错误提示',
    'autoSave.modal.edit.history': '查看编辑记录',
    'autoSave.modal.content': '当前预览主题不是最新版本，无法保存，请刷新页面后再进行编辑',
    'autoSave.modal.error': '保存失败：',
    'dropdown.message.deleted': '已删除',
    'dropdown.packageName.published': '已发布',
    'dropdown.packageName.unpublish': '暂未发布',
    'dropdown.ThemeEdit.setting.tip': '主题设置',
    'dropdown.ThemeEdit.delete.tip': '删除主题',
    'dropdown.ThemeEdit.delete.confirm.desc': '删除主题后，该主题将无法在现网址下被访问，请谨慎操作！',
    'dropdown.ThemeEdit.delete.btn': '删除',
    'dropdown.ThemeEdit.cancel.btn': '取消',
    'dropdown.ThemeEdit.copy.success': '已复制到剪切板',
    'dropdown.ThemeEdit.copy.error': '复制失败',
    'dropdown.ThemeEdit.supplement.text': '查看 ',
    'dropdown.ThemeEdit.supplement.history': '版本记录',
    'dropdown.ThemeEdit.menu.title': 'Arco 组件库版本',
    'dropdown.ThemeEdit.menu.tag.latest': '最新',
    'dropdown.ThemeEdit.menu.tag.updatable': '可更新',
    'dropdown.ThemeEdit.origin.title': '查看父主题',
    'dropdown.ThemeEdit.origin.synchronization': '同步',
    'dropdown.ThemeEdit.origin.check': '查看',
    'dropdown.ThemeEdit.toggle.title': '切换主题',
    'dropdown.ThemeEdit.preview': '主题预览',
    'dropdown.ThemeEdit.config': '配置详情',
    'preview.action.back': '返回配置',
    'preview.pkgname.text': '效果预览',
    'preview.action.guideline': '帮助文档',
    'preview.action.publish': '发布',
    'preview.version': '预览版本',
    'preview.version.current': '当前预览版本为'
  }
};
export default i18n;